// Image gallery

$(function () {
  $('.jsImagePopup').magnificPopup({
    delegate: 'a',
    type: 'image',
    gallery: {enabled: true}
  })

  const itemsCount = $('.jsGallery a').length;

  $('.jsGallery').owlCarousel({
    rewind: true,
    autoWidth: true,
    margin: 20,
    nav: false,
    autoplay: true,
    autoplayTimeout: 2000,
    items: itemsCount
  });
})
